<template>
  <tr class="is-size-6"
      :id="'e' + program.program"
      :class="{'has-status-bar--left has-status-bar--draft': scrollToEl === program.program}">
    <td class="has-text-centered is-paddingless is-cell-hoverable">
      <router-link  v-if="!multiselection" :to="{name: 'ProgramVue', params: {id: program.program}, query: {returnId: program.program, page: this.currentProgramPage}}">
        <avatar :item="program" :i="i"></avatar>
      </router-link>
      <multiselect-button v-else
                          :data="program"
                          :is-checked="checkedItem"
                          :multiselection="multiselection"
                          @selected="$emit('selected', $event, program.program)">
      </multiselect-button>
    </td>
    <td class="is-cell-hoverable is-nowrap">
      <router-link :to="{name: 'ProgramVue', params: {id: program.program}, query: {returnId: program.program, page: this.currentProgramPage}}" class="xfullLink">
        {{program.name | truncate}}
      </router-link>
      <span class="icon has-text-grey tooltip is-tooltip-right"
            data-tooltip="Flux promoteur"
            v-if="isDistributeurMode && !isExternal && program.from_flux">
        <i class="fas fa-rss"></i>
      </span>
      <span class="tag is-exclusif is-small" v-if="program.is_exclusive">Exclusivité</span>
      <p class="has-text-annonce is-small is-italic" v-if="!program.is_optionable">Non optionnable</p>
    </td>
    <td v-if="isDistributeurMode && !isExternal && showColumn('promotor_name')"
        class="is-cell-hoverable is-nowrap">
      <router-link :to="{name: 'PromoteurVue', params: {id: program.promoteur}, query: {returnId: program.program, page: this.currentProgramPage}}" v-if="isAdmin || isEditor">
        {{program.promoteur_name}}
      </router-link>
      <span v-else>{{program.promoteur_name}}</span>
    </td>
    <td v-if="(isAdmin || isEditor) && showColumn('status')">
      <span class="tag"
            :class="tagColor(program.program_status)">{{program.program_status | workflowLabel}}</span>
    </td>
    <td v-if="showColumn('tax_dispositifs')" class="is-narrow">
      <span v-if="program.tax_dispositifs && program.tax_dispositifs.length" :title="program.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
        {{program.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate}}
      </span>
    </td>
    <td v-if="showColumn('zip_code')">
      <span v-if="program.address.zip_code">{{program.address.zip_code}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="showColumn('city')" class="is-nowrap">
      <span v-if="program.address.city">{{program.address.city}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="showColumn('date_livraison')">
      <span v-if="program.date_livraison">{{program.date_livraison | trimestre}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="showColumn('date_actabilite')">
      <span v-if="program.date_actabilite">{{program.date_actabilite | actableStatus}}</span>
      <span v-else></span>
    </td>
    <td v-if="isPromoteurMode && isExternal && showColumn('lot_dispo')">
      <span v-if="allotment">{{allotment}}</span>
      <span v-else>-</span>
    </td>
    <td v-else-if="!(isDistributeurMode && isExternal) && showColumn('lot_dispo')">
      <span v-if="program.lot_counts.available || program.lot_counts.optioned">{{(program.lot_counts.available || 0) + (program.lot_counts.optioned || 0)}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="!isExternal && showColumn('lot_total')">
      <span v-if="program.lot_counts.total">{{program.lot_counts.total}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="!isExternal && showColumn('remuneration') && displayRemuneration">
      <span v-if="program.remuneration">{{program.remuneration|prettyPrice}}%</span>
      <span v-else>--</span>
    </td>
    <td v-if="showColumn('progress_step')">
      <span v-if="program.progress_step" class="tag is-info">{{programStepProgressLabel(program.progress_step)}}</span>
      <span v-else>-</span>
    </td>
    <td v-if="(isAdmin || isEditor) && showColumn('diffusion_enabled')">
      <span v-if="program.diffusion_enabled">Oui</span><span v-else>Non</span>
    </td>
    <td v-if="isAdmin && showColumn('created_on')">
      {{program.created_on | prettyDate }}
    </td>
    <td class="has-text-centered actions">
      <display-button-list :buttons="buttonList" :data="program"
                          :openUp="{'position': i, 'total': programsCount}">
      </display-button-list>
    </td>
  </tr>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { ColumnConf, GenericList, DefaultValues } from '@/mixins'
  import { compact } from 'lodash'

  export default {
    name: 'StockProgramListItem',
    props: {
      source: Object,
      i: Number,
      programsCount: Number,
      columnsShowSource: Object,
      columnsSource: Array,
      multiselection: {
        type: Boolean,
        default: false
      },
      selectedItems: {
        type: Array,
        default: () => []
      },
      currentProgramPage: Number
    },
    mixins: [ColumnConf, GenericList, DefaultValues],
    data () {
      return {
        service: this.$api.programService,
        columnsConfResource: 'program',
        columnsShow: this.columnsShowSource,
        columns: this.columnsSource,
        allotment: null,
        buttonList: [
          {
            icon: 'fas fa-file-invoice',
            text: 'Fiche programme',
            action: (id, data) => {
              this.$router.push({name: 'ProgramVue', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            icon: 'fas fa-edit',
            text: 'Modifier fiche programme',
            needProfile: ['admin', 'editor'],
            action: (id, data) => {
              this.$router.push({name: 'ProgramEdit', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            icon: 'fas fa-folders',
            text: 'Gestions documents',
            needProfile: ['admin', 'editor'],
            action: (id, data) => {
              this.$router.push({name: 'ProgramDocumentEdit', params: {id: data.program}, query: {returnId: data.program, page: this.currentProgramPage}})
            }
          },
          {
            action: (id, data) => {
              this.deleteItem(data.program)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer programme',
            needProfile: ['admin']
          }
        ]
      }
    },
    computed: {
      ...mapState(['scrollToEl']),
      ...mapGetters(['isAdmin', 'isExternal', 'isEditor', 'isDistributeurMode', 'isPromoteurMode', 'currentCompanyPk', 'displayRemuneration']),
      program () {
        return this.source
      },
      checkedItem () {
        return this.selectedItems.includes(this.program.program)
      }
    },
    filters: {
      prettyTaxDispositifs (values, data) {
        return compact(values.map(x => {
          if (x in data) {
            return data[x].short_label || data[x].label
          }
        })).join(', ')
      },
      actableStatus (v) {
        let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
        let date = new Date()
        let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
        if (!v) {
          return 'NC'
        } else if (currentTrim > v) {
          return 'Oui'
        } else if (currentTrim <= v) {
          return 'Non'
        }
      }
    },
    watch: {
      columnsShowSource (v) {
        this.columnsShow = v
      },
      columnsSource (v) {
        this.columns = v
      }
    },
    methods: {
      afterSuccessDelete () {
        this.$emit('reload')
      },
      tagColor (value) {
        const COLORS = {
          'private': 'is-private',
          'available': 'is-disponible',
          'draft': 'is-draft',
          'archived': 'is-draft'
        }
        return COLORS[value]
      },
      getAllotment () {
        let param = {
          program: this.program.program,
          company: this.currentCompanyPk
        }
        this.$api.accessService.getAllotments(param).then(r => {
          this.allotment = r.data.total
        })
      }
    },
    created () {
      if (this.isPromoteurMode && this.isExternal) {
        this.getAllotment()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stock/StockProgramListItem.vue